// extracted by mini-css-extract-plugin
module.exports = {"errorContent":"ErrorContent_errorContent__UR6Ep","iconWrapper":"ErrorContent_iconWrapper__5Mzn7","title":"ErrorContent_title__FA4xU","text":"ErrorContent_text__NgoMi"};